import Vue from 'vue'
import Vuex from 'vuex'
import product from './modules/product'
import shopping from './modules/shopping'
import order from './modules/order'
import companyAddr from './modules/companyAddr'
import work from './modules/work'
import user from './modules/user'
import clothing from './modules/clothing'
import getters from './getters'
import permission from './modules/permission'
import label from './modules/label'
import channell from './modules/channel'
import theme from './modules/theme'

Vue.use(Vuex)

const store = new Vuex.Store({
  getters,
  actions: {
  },
  modules: {
    product,
    shopping,
    order,
    companyAddr,
    work,
    clothing,
    user,
    permission,
    label,
    channell,
    theme
  },
  state: {
    // tags数组
    tags: [],
    // tagsview标签显示隐藏
    isCollapse: false
  },
  mutations: {
    pushtags(state, val) {
      //如果等于-1说明tabs不存在那么插入，否则什么都不做
      //findindex找角标，循环判断一下，如果等于那么就代表有相同的，就不必添加，如果找不到那就是-1.就添加
      // console.log('store', this.$route);
      // console.log('store', state, val);
      let result = state.tags.findIndex(item => item.name === val.name)
      result === -1 ? state.tags.push(val) : ''
    },
    //关闭标签（固定页不可关）
    closeTab(state, val) {
      if (val && val.meta && val.meta.affix) {
        return
      }
      //同上，找角标，然后用角标的位置对应删除一位。splice：这是数组的删除方法
      let result = state.tags.findIndex(item => item.name === val.name)
      if (result !== -1) {
        state.tags.splice(result, 1)
      }
    },
    closeOtherTabs(state, keepTag) {
      state.tags = state.tags.filter(
        item =>
          item.name === keepTag.name ||
          (item.meta && item.meta.affix)
      )
    },
    closeAllTabs(state) {
      state.tags = state.tags.filter(item => item.meta && item.meta.affix)
    },
  }
})
export default store
